<yc-modal *ngIf="formGroup"
  [formGroup]="formGroup"
  [modalHeader]="modalHeader"
  [modalSubHeader]="isNew ? '' : budget.name"
  [cancelButtonText]="'common:btnCancel' | ycI18n: 'Cancel'"
  [secondaryButtonText]="secondaryButtonText"
  [primaryButtonText]="primaryButtonText"
  [primaryDisabled]="primaryDisabled"
  (onPrimaryClick)="onPrimaryClick()"
  (onSecondaryClick)="onSecondaryClick()"
  (onCancel)="onCancel()">

  <div [ycHidden]="scenario !== CreateEditBudgetScenario.Standard">
    <div class="details-header mb-2">
      <yc-i18n
        key="GLOBAL:textDetails"
        defaultValue="Details">
      </yc-i18n>
    </div>

    <!-- Name -->
    <div class="mb-2">
      <yc-input
        name="name"
        [disabled]="budget?.isClosed"
        [label]="'BUDGET:lblBudgetName' | ycI18n:'Budget name'">
      </yc-input>
    </div>

    <!-- Description -->
    <div class="mb-2">
      <yc-textarea
        [disabled]="budget?.isClosed"
        name="description"
        [label]="'BUDGET:lblBudgetDescription' | ycI18n:'Budget description'">
      </yc-textarea>
    </div>

    <!-- Account Number -->
    <div *ngIf="!hideFundingSources" 
      class="mb-2">
      <ng-template *ngTemplateOutlet="accountNumberInput"></ng-template>
    </div>

    <ng-container *ngIf="hideFundingSources">
      <div class="details-header mt-3">
        <yc-i18n
          key="BUDGET:hdrBudgetAndProcessing"
          defaultValue="Budget and Processing">
        </yc-i18n>
      </div>

      <div class="details-subheader">
        <yc-i18n
          key="BUDGET:textBudgetAndProcessingDesc"
          defaultValue="Provide processing information for your budget, including its type and the total cash amount to make available for payments.">
        </yc-i18n>
      </div>

      <div class="d-flex flex-column mt-2">
        <!-- Row 1 -->
        <div class="d-flex mb-2 align-items-center">
          <div class="flex-basis-50 me-3">
            <!-- Funding Source Type -->
            <yc-typeahead-select
              name="fundingSourceType"
              [label]="'common:hdrType' | ycI18n"
              [items]="typeOptions"
              [showClear]="false"
              [disabled]="!!budget"
              [help]="!!budget ?
                ('BUDGET:textTypeCannotBeChanged' | ycI18n: 'Type cannot be changed') :
                ''">
            </yc-typeahead-select>
          </div>
          <div [class.flex-basis-50]="isCash"
            [class.flex-grow-1]="!isCash"
            [class.me-3]="!isCash">
            <!-- Budget Total -->
            <yc-input
              name="budgetTotal"
              [label]="'common:textBudgetTotal' | ycI18n: 'Budget total'"
              [showQuestionMarkForTooltip]="true"
              [disabled]="budget?.isClosed"
              [currencyData]="currencyData"
              [popoverTemplate]="budgetTotalPopoverTemplate"
              [rightIcons]="rightIcons"
              [isNumber]="true">
            </yc-input>
          </div>

          <!-- Show Calculator -->
          <div *ngIf="!isCash && !budget?.isClosed"
            class="mt-3">
            <yc-button
              [link]="true"
              [langKey]="'common:textCalculateTotal'"
              [defaultText]="'Calculate total'"
              (onClick)="onShowCalculator()">
            </yc-button>
          </div>
        </div>

        <!-- Row 2 -->
        <div class="d-flex">
          <div *ngIf="showProcessorSelect"
            class="flex-basis-50 me-3">
            <!-- Processor -->
            <yc-typeahead-select
              name="processor"
              [label]="'BUDGET:textPaymentProcessor' | ycI18n: 'Payment processor'"
              [items]="processorOptions"
              [disabled]="budget?.isClosed"
              [showQuestionMarkForTooltip]="true"
              [showClear]="false"
              [tooltipText]="'BUDGET:textPaymentProcessorHelp' | ycI18n: 'This indicates who will be responsible for disbursing the funds from this funding source'">
            </yc-typeahead-select>
          </div>
          <div class="flex-basis-50">
            <ng-template *ngTemplateOutlet="accountNumberInput"></ng-template>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="details-header mt-3">
      <yc-i18n
        key="GLOBAL:lblTags"
        defaultValue="Tags">
      </yc-i18n>
    </div>

    <div class="details-subheader">
      <yc-i18n
        key="BUDGET:textTagsDesc"
        defaultValue="System tags can be assigned to this budget to aid in filtering and reporting.">
      </yc-i18n>
    </div>

    <gc-system-tags-input
      [availableTags]="availableTags"
      [tagType]="Buckets.Budget"
      [formGroup]="tagsFormGroup"
      [showLabel]="false"
      [isOptional]="true"
      [showHelp]="false"
      (onAddNewTagToggle)="addingNewTag = $event">
    </gc-system-tags-input>


    <ng-template #accountNumberInput>
      <yc-input
        name="accountNumber"
        [disabled]="budget?.isClosed"
        [showQuestionMarkForTooltip]="true"
        [popoverTemplate]="accountNumberPopover"
        [label]="'GLOBAL:textAccountNumber' | ycI18n: 'Account number'">
      </yc-input>
    </ng-template>
  </div>


  <!-- Calculator View -->
  <div *ngIf="hideFundingSources" 
    [ycHidden]="scenario !== CreateEditBudgetScenario.Calculator">
    <gc-funding-source-calculator
      [newInKindItemAllocation]="newInKindItemAllocation"
      [newCategoryId]="newCategoryId"
      [description]="calculatorDescription"
      (onTotalChange)="onTotalCalculatorChange($event)">
    </gc-funding-source-calculator>
  </div>


  <!-- In-kind Item Add -->
  <div *ngIf="(
    scenario === CreateEditBudgetScenario.AddInKindItem ||
    scenario === CreateEditBudgetScenario.AddInKindCategory
    )">
    <gc-budget-add-in-kind-item
      [scenario]="scenario"
      [newCategoryId]="newCategoryId"
      (onAddingCategory)="onAddingInKindCategory($event)"
      (onChange)="onNewInKindItemChange($event)"
      (onValidChange)="onNewItemValidChange($event)"
      (onCategoryChange)="onCategoryChange($event)">
    </gc-budget-add-in-kind-item>
  </div>
</yc-modal>


<ng-template #budgetTotalPopoverTemplate>
 <ng-container *ngIf="isCash">
  <yc-i18n
    key="BUDGET:textBudgetTotalDesc"
    defaultValue="This total is used to fund payments. It can be increased later if needed.">
  </yc-i18n>
 </ng-container>
 <ng-container *ngIf="!isCash">
  <yc-i18n
    key="BUDGET:textBudgetTotalInKindDesc"
    defaultValue="This total is the cash value of your in-kind items to be awarded. Use the calculator to provide an estimate. It can be increased later if needed.">
  </yc-i18n>
  <a [href]="inKindHelpLink"
    target="_blank"
    (click)="trackClick(inKindHelpLink)"
    class="ms-2">
    <yc-i18n
      key="common:textLearnMore"
      defaultValue="Learn more">
    </yc-i18n>
  </a>
 </ng-container>
</ng-template>

<ng-template #accountNumberPopover>
  <yc-i18n
    key="BUDGET:textAccountNumberDesc"
    defaultValue="This can be any unique ID to use for Accounts Payable integration and reporting.">
  </yc-i18n> 
  <a [href]="accountNumbersHelpLink"
    target="_blank"
    (click)="trackClick(accountNumbersHelpLink)"
    class="ms-2">
    <yc-i18n
      key="common:textLearnMore"
      defaultValue="Learn more">
    </yc-i18n>
  </a>
</ng-template>
